import { AxiosError } from "axios";
import { Notify } from "quasar";

interface ErrorResponse {
  error: string;
}

function genericErrorHandler(e: AxiosError<ErrorResponse>) {
  const errorMessage = e.response?.data?.error;

  if (errorMessage) {
    Notify.create({
      type: "negative",
      message: errorMessage,
    });
    return;
  }

  switch (e.response?.status) {
    case undefined:
      // When there is no response returned
      Notify.create({
        type: "negative",
        message: "Network error, please retry later.",
      });
      break;
    case 400:
      Notify.create({
        type: "negative",
        message: "Invalid form, please check your inputs.",
      });
      break;

    //401 is taken care of by axios interceptor

    case 403:
      Notify.create({
        type: "negative",
        message: "You do not have the sufficient permission.",
      });
      break;
    case 404:
      Notify.create({
        type: "negative",
        message: "Requested resource does not exist.",
      });
      break;
    case 429:
      Notify.create({
        type: "negative",
        message: "You requested too many times, please retry later.",
      });
      break;
    case 500:
      Notify.create({
        type: "negative",
        message: "Internal error has occurred, please retry later.",
      });
      break;
    default:
      Notify.create({
        type: "negative",
        message: "Unknown error, please check your connection status.",
      });
      break;
  }
}

export { genericErrorHandler };
